import AlternativeDomFactory from '../factory/alternative-factory';
import Builder from '../../common/builder/builder';
import { AlternativeStatus } from '../model/alternative';

type Elements = {
  wrapper: HTMLElement;
  letter?: HTMLElement;
  text?: HTMLElement;
  checkbox?: HTMLInputElement;
};

export default class AlternativeBuilder extends Builder<
  Elements,
  AlternativeDomFactory
> {
  public withId(id: string) {
    this.elements.wrapper.id = id;
    return this;
  }

  public withLetter(letter: string) {
    this.elements.letter = this.factory.createAlternativeLetter(letter);
    this.elements.wrapper?.appendChild(this.elements.letter);
    return this;
  }

  public withAnswer(answer: string) {
    this.elements.text = this.factory.createAlternativeText(answer);
    this.elements.wrapper?.appendChild(this.elements.text);
    return this;
  }
  public withStatus(status: AlternativeStatus) {
    const classMap = {
      correct: 'alternative-correct',
      incorrect: 'alternative-incorrect',
      empty: 'alternative-empty',
    };
    this.elements.wrapper?.classList.add(classMap[status]);
    return this;
  }
  public withCheckbox(onCheckAnswer?: () => void, disabled?: boolean) {
    this.elements.checkbox = this.factory.createAlternativeRadio();
    this.elements.wrapper?.appendChild(this.elements.checkbox);
    if (onCheckAnswer) {
      this.elements.checkbox?.addEventListener('change', onCheckAnswer);
    }
    if (disabled) {
      this.elements.checkbox?.setAttribute('disabled', 'disabled');
    }
    return this;
  }

  public onCheckAnswer(callback: (e: Event) => void) {
    this.elements.checkbox?.addEventListener('change', callback);
    return this;
  }
}
